import React from "react";
import LogoDark from "../assets/LogoDark.svg";

const Logo = () => {
  return (
    <div>
      <img src={LogoDark} alt="Logo" width={120} height={30} />
    </div>
  );
};

export default Logo;
